import styled, { css } from 'styled-components';
import { Lock } from '@mui/icons-material';
import { IconButton } from '@mui/material';

import { Title } from '../../../../../components/v2/Header';
import {
  LinkButton,
} from '../../../../../components/Button';

import colors from '../../../../../styles/colors';
import { mixins } from '../../../../../styles/breakpoints';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 20px;
`;

const SignUpContent = styled.div`
  display: flex;
  flex-direction: column;
`;

const ErrorContainer = styled.div`
  margin-top: 20px;
`;

const StyledLinkButton = styled(LinkButton)`
  margin-top: 10px;
  text-decoration: underline;
  display: block;
  font-size: 16px;
  cursor: pointer;
  margin: auto;
  color: ${({ $isDarkTheme }) => ($isDarkTheme ? colors.base.alpha : colors.base.beta)};
  &:hover {
    color: ${colors.shades.gamma10};
  }
`;

const NameContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
`;

const StyledTitle = styled(Title)`
  text-transform: uppercase;
  font-size: 12px;
  margin-bottom: 10px;
  color: ${({ $isDarkTheme }) => ($isDarkTheme ? colors.shades.dark4 : colors.base.gama)};
`;

const HelperTextContainer = styled.div`
  display: flex;
  align-items: center;
  color: ${colors.shades.gamma10};
  margin-bottom: 50px;
  font-size: 12px;

  ${mixins.upToDesktopMedia(css`
    margin-bottom: 20px;
  `)}
`;

const StyledLockIcon = styled(Lock)`
  margin-right: 5px;
  width: 15px;
  height: 15px;
`;

const StyledIconButton = styled(IconButton)`
  color: ${colors.shades.gamma10};
`;

const PersonalDataInputContainer = styled.div`
  margin-bottom: 16px;
`;

const SignInActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-top: 12px;

  ${StyledLinkButton} {
    margin-top: 5px;
    padding: 0;
  }
`;

const ResetPasswordMessage = styled.div`
  margin-top: 10px;
  font-size: 14px;
  text-align: center;
  color: ${({ $isError }) => ($isError ? colors.base.danger : colors.shades.success2)};
`;

export {
  Container,
  SignUpContent,
  ErrorContainer,
  StyledLinkButton,
  NameContainer,
  StyledTitle,
  HelperTextContainer,
  StyledLockIcon,
  StyledIconButton,
  PersonalDataInputContainer,
  SignInActionsContainer,
  ResetPasswordMessage,
};
